import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FreshchatService } from './core/freshchat.service';
import { LogRocketService } from './core/logrocket.service';
import { environment } from 'src/environments/environment';
import { AppUsageService } from './pages/app-usage/app-usage.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    menuMode = 'sidebar';
    layout = 'blue';
    theme = 'blue';
    ripple: boolean;
    colorScheme = 'dark';

    constructor(private primengConfig: PrimeNGConfig,
        private translateService: TranslateService,
        private appUsage: AppUsageService,
        private freshchatService: FreshchatService,
        private logRocketSercice: LogRocketService,
        public afAuth: AngularFireAuth) {
        this.translateService.setDefaultLang('es-ES');
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.translate("es-ES");
        this.ripple = true;
        this.appUsage.logAppUsage();
        if (environment.production) {
            this.logRocketSercice.init();
            this.logRocketSercice.setUserId();
            this.freshchatService.init();
            this.freshchatService.setUserId();
        }
        if (environment.useEmulators)
            this.afAuth.useEmulator('http://localhost:29099');
    }

    translate(lang: string) {
        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
    }
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
